import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  Menu.userInformation,
  Menu.userEdit,
  Menu.userDelete,
  Menu.userClone,
  Menu.usersHelp,
];
